import { render, staticRenderFns } from "./customDashboardNotifications.vue?vue&type=template&id=16f3cba0&scoped=true"
import script from "./customDashboardNotifications.vue?vue&type=script&lang=js"
export * from "./customDashboardNotifications.vue?vue&type=script&lang=js"
import style0 from "./customDashboardNotifications.vue?vue&type=style&index=0&id=16f3cba0&prod&lang=css"
import style1 from "./customDashboardNotifications.vue?vue&type=style&index=1&id=16f3cba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3cba0",
  null
  
)

export default component.exports